import BigNumber from 'bignumber.js';
import { Address, encodeFunctionData, WalletClient } from 'viem';

import stakingTokenAbi from 'modules/api/abi/LiquidStakingToken';
import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { convertToWei } from 'modules/api/utils';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

export async function unstake(
  walletClient: WalletClient,
  data: {
    amount: BigNumber;
    poolAddress?: Address;
  },
): Promise<Address> {
  const { amount, poolAddress = LIQUID_STAKING_TOKEN_ADDRESS } = data;

  const encodedData = encodeFunctionData({
    abi: stakingTokenAbi,
    functionName: 'requestUnstake',
    args: [convertToWei(amount)],
  });

  const txHash = await walletClient.sendTransaction({
    to: poolAddress,
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address),
  });

  return txHash;
}
